import { render, staticRenderFns } from "./BnDevisDetails.vue?vue&type=template&id=f4720498&"
import script from "./BnDevisDetails.vue?vue&type=script&lang=js&"
export * from "./BnDevisDetails.vue?vue&type=script&lang=js&"
import style0 from "./BnDevisDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports